module.exports = __webpack_public_path__ + "img/hhmapfull.70000828.svg";